<script>
export default 
{
      data () {
       return {
            users : null,
       }
       },
      mounted () {
            console.log("starting")
            this.$http.get('users-noadmin').then(res => {
        this.users = res.data
      }).finally(() => {
        let i
        for ( i = 0; i < this.users.length; i++) {
            let flagM = false
            if(Date.parse(this.users[i].expiration_date)==null)
            {
                  flagM = true
                  this.users[i].status=true
            }
            if(Date.parse(this.users[i].expiration_date) < Date.parse(getCDate(0,0,0)))
            {
                  flagM = true
                  this.users[i].status=false
            }
            if(Date.parse(this.users[i].expiration_date) >= Date.parse(getCDate(0,0,0)))
            {
                  flagM = true
                  this.users[i].status=true
            }
            if(flagM)
            {
              if(this.users[i].expiration_date!=null)
            {
                  if(this.users[i].expiration_date.length!=0 )
                  {
                  var intDate = Date.parse(this.users[i].expiration_date)
                  intDate = intDate + ( 24 * 60 * 60 * 1000)
                  var new_Date = new Date()
                  new_Date.setTime(intDate)
                  this.users[i].expiration_date = new_Date
                  }
            }
              this.$http.post('users-noadmin', this.users[i])
            }
         }
         console.log("done")
            })
      }
}

function getCDate(pY,pM,pD)
    {
      let current = new Date();
      let cDate = (current.getFullYear() + pY) + '-' + (current.getMonth() + 1 + pM) + '-' + (current.getDate()+pD);
      return cDate;
    }
</script>